import React from 'react'
import cx from 'classnames'
import { t } from 'ttag'
import { Box } from 'components/layout/Box/Box'
import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { Checkbox } from 'components/shared/FormFields/common/Checkbox/Checkbox'
import styles from './DropdownMenu.module.scss'

const Check = ({ label, name, value, onChange }) => {
  const ref = React.useRef()

  return (
    <div className={styles.checkboxContainer}>
      <Checkbox
        value={value}
        id={name}
        name={name}
        onChange={onChange}
        ref={ref}
      />
      <label className={styles.label} for={name}>
        {label}
      </label>
    </div>
  )
}

export const DropdownMenu = ({
  className = undefined,
  categoriesFilter = {},
  valueFilter = {},
  updateValueFilter,
  updateCategoryFilter,
}) => {
  const labels = {
    highTalent: t`High match areas`,
    mediumTalent: t`Medium match areas`,
    lowTalent: t`Low match areas`,
  }

  return (
    <Dropdown.Menu
      className={cx(styles.menu, { [className]: Boolean(className) })}
    >
      <div className={styles.filterColumns}>
        <Box direction="column" className={styles.filters}>
          <div className={styles.valueAreasLabel}>{t`Talent areas`}</div>
          {Object.keys(valueFilter).map(key => {
            return (
              <Check
                label={labels[key]}
                name={key}
                onChange={updateValueFilter}
                value={valueFilter[key]}
              />
            )
          })}
        </Box>
        <Box direction="column" className={styles.filters}>
          <div className={styles.valueAreasLabel}>{t`Categories`}</div>
          {Object.keys(categoriesFilter).map(key => {
            return (
              <Check
                label={key}
                name={key}
                onChange={updateCategoryFilter}
                value={categoriesFilter[key]}
              />
            )
          })}
        </Box>
      </div>
    </Dropdown.Menu>
  )
}
